<template>
<div style="display:inline">
<svg v-if="!externalIcon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="2.118046998977661 2.1359703540802 291.91595458984375 277.6761474609375" preserveAspectRatio="xMidYMid meet" :height="height" :width="width">
    <defs>
      <linearGradient :id="'grad' + partType" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" :style="leftColour" />
        <stop offset="100%" :style="rightColour" />
      </linearGradient>
    </defs>
    <rect id="svgEditorBackground" x="0" y="0" width="299" height="288" style="fill:none; stroke: none;"/>
    <g style="fill:rgb(4,76,116);fill-rule:evenodd;stroke:rgb(4,76,116);stroke-width:0.1;" id="l1">
      <path d="M0,0h299v288h-299Z" style="fill:none;"/><path d="M145,20h2l3,1l2,2l1,2v5l-1,2l-1,1l-3,1h-4l-2-1l-2-2v-7l1-2l1-1zm62,18h5l2,2v1h2l1,2v5l-2,2h-1v2h-8l-2-1l-2-4v-3l1-1h1v-3l1-1zm-112,50h8l2,2l1,3v3l-1,3l-1,1l-2,1h-6l-3-3l-1-2v-3l1-3zm-78,15h7l2,1c0,2,1,2,2,3v6l-1,2l-4,2h-5l-2-1l-2-2v-7l1-1h1l-1-1v-1z"/><path d="M280,103h4l3,1v2h2l1,5v1l-1,2l-3,3h-7l-2-1l-1-2l-1-6v-1l3-3zm-67,60h4l2,1l2,2l1,2v4l-2,4l-2,1h-6l-3-3l-1-2v-3l1-3l2-2zm-196,16h7l2,1l1,2v7l-1,1h-1v2l-4,1h-1l-3-1l-2-2l-1-2v-5l1-2zm140,36h6l3,3l1,1v6l-2,2c-2,0-2,1-3,2h-4l-1-1v-1h-2l-1-1l-1-2v-5z"/><path d="M236,235h7l3,3v7l-2,2l-2,1h-5l-2-1l-2-2l-1-2v-3l1-2zm-139,19h5v2h2l2,2v6l-1,2l-2,2h-8l-1-1c0-2-1-2-2-3v-5l1-2l2-2z"/></g><g style="fill:rgb(4,84,116);fill-rule:evenodd;stroke:rgb(4,84,116);stroke-width:0.1;" id="l2"><path d="M205,30h8l2,1v1h4c0,2,1,2,3,4l1,1c0,2,1,2,2,3v9l-1,3l-1,1h-1v2l-3,3l-2,1c-2,0-2,1-3,2h-1l-7-1l-1-1l1,1v1l-1,2h-2v3l-1,1h-1v2l-2,2h-1v3l-1,1h-1v3l-1,1h-1v2l-1,2l-1,1h-1v2l-1,2c-2,0-1,1-1,2h-2v2l-2,2h-1l1,1v1h-2v4l-3,3h-1v3l-2,4l-1,1c-2,0-1,1-1,2l-1,2h-2v4l-2,1c-1,0-1,2-2,5l-2,2h-1v2l-2,4l-1,1h-1v2l-1,2l-1,1h-1v2l-1,2l-2,2h-1v-15h2v-3l1-1h1v-3l1-2h2v-2l1-1h1v-3l1-1h1v-2l2-4l1-1h1v-2l1-1h1v-3l1-2l2-2h1v-2l1-2l2-2h1v-4c2,0,1-1,1-2c2,0,2-2,5-8c2,0,2-2,3-4h1v-3l1-1c2,0,2-2,3-5l2-2h1v-4l2-1h1l-1-1l-1-2c0-2-1-2-2-3l-1-4v-4l2-6l1-1h2v-3h1l1,1l-1-1v-1h1c1,1,1,0,2-1zm-1,10v3l-1,1h-1v3h1l1,2v2h2l8,1v-2l2-2h1l-1-1v-6h-2l-2-2v-1l-5,1h-2v1z"/><path d="M17,95h10c0,2,1,1,2,1l3,3c0,2,1,2,2,3c0,2,1,2,2,3c0,6,3,6,4,7v1h3l3,1v4l-2,4h-1l-4-1l-3-1v-1c-4,0-4,2-5,3l-4,2l-3,1h-9l-3-1v-1l1-1h-3l-1-1v-2h-2v-1l1-1h-2l-1-9v-1l2-6h1l1,1v-3l1-1l4-2zm-3,12v7h1l1,1v1h2l5,1v-1l2-1h2v-7l1-1h-1l-1-1v-2h-11l1,1v1l-1,1zm263-12h11l2,1l3,3v2h2c0,2,1,2,2,3l1,2v7l-1,2l-1,1h-1v4l-2,2h-1l-1-1v2l-1,1l-4,1h-10l-2-1l-1-1v-2h-2l-1-2v-1h-2v1l-2,1c-4,0-4,1-7,2c-3,0-3,1-5,2h-2l-1-1v2h-2c0-4-1-4-2-7v-2l3-1h1c1,1,1,0,2-1h1c1,1,1,0,3-1c5,0,5-1,6-2c4,0,4-5,5-8l3-3h1v-2l2-1c2,0,2-1,3-2zm-2,12l1,1v6h1v2h2v1h7v-1l2-2h1v-2h1l-1-1v-5h-2v-2h-3l-4-1v1h-2v1l-2,2z"/><path d="M62,120h3l4,1l1,1v1h4l3,1l2,1v1h3l2,1v1h4l4,1l3,1l1,1v1l1,-1h2l4,2c0,1,3,1,7,2l3,1l2,1v1h3l3,1v1h4l2,1v3h2l1,2v2c-4,0,-4,1,-5,2h-1l-1,-1v-1h-3l-2,-1v-1h-5l-2,-1c0,-1,-3,-1,-7,-2l-6,-2l-1,-1v-1l-2,1h-1l-1,-1v-1h-4l-2,-1v-1h-4l-1,-1v-1l-1,1h-2l-1,-1v-1h-3l-3,-1v-1h-4l-1,-1v-1h-3l-3,-1l-1,-1v-2l1,-2h1Z"/><path d="M230,121h1l2,6v3l-2,1l-4,1h-1c-1-1-1,0-2,1c-4,0-4,1-6,2l-3,1c-5,0-5,1-7,2h-5v1c-3,0-3,1-5,2h-1c-1-1-1,0-2,1c-4,0-4,1-7,2h-1c-1-1-1,0-5,2h-1l-1-1v1c-3,0-3,1-5,2h-1c-1-1-1,0-3,1l-3,1c-4,0-4,1-6,2h-5v-1l1-4c2,0,2-2,3-4l2-1l3-1h1c1,1,1,0,2-1l4-1h5v-2h1c1,1,1,0,3-1l4-1h4v-1c3,0,3-1,5-2h1c1,1,1,0,3-1l6-2h5v-1c3,0,3-1,4-2h1l1,1v-1c3,0,3-1,5-2h2c1,1,1,0,3-1c3,0,3-1,4-2z"/><path d="M139,162h1l1,4v2c-1,1,0,1,1,3v1l-1,2h-1v3l-1,3l-1,2h-1v3l-3,6h-1v3l-1,1h-1v5l-1,2l-1,1h-1v3l-1,3h-2v5l-1,2l-1,1h-1v2l-1,1h-1l1,1v1l-1,1h-1v5h-2v3l-1,1h-1l1,1v1l-1,1h-1l1,1v1l-2,4c-2,0-1,1-1,2l-1,1h-1l1,1v1l-1,1h-1v2h-1l2,2v1h2v1l-1,1h2l1,1l1,5v2l-1,3h-1l1,1v1l-2,4l-1,1h-2v2h-1l-1-1v2l-1,1h-12l-6-3l-2-2c0-3-1-3-2-4v-11l1-2l1-1h1v-2h2v-2c2,0,2-1,3-2l3-1c7,0,7-2,8-5l1-3l1-1h1v-3l1-3c2,0,1-1,1-2l1-3l1-1h1v-4c2,0,2-3,3-6l1-1h1l-1-1v-1l1-1h1v-2h1l-1-1v-1h2v-2h1v-4l1-3l2-4l1-1h1v-3l1-3l1-1h1v-3l1-3l1-2l1-1h1v-3l1-2h1v-3l1-3zm-17,53v1h1v-1zm-16,43h-1l-1-1v-1h-2v-2h-5v1h-2v1l-1,1h-1v2h-1v5h1l1,1l1,2v1h8v-1l1-1h1v-2h1l-1-4v-1zm-19,12v1h1v-1zm25-14h1v-1h-1z"/></g><g style="fill:rgb(108,188,76);fill-rule:evenodd;stroke:rgb(108,188,76);stroke-width:0.1;" id="l3"><path d="M141,12h11l1,1v1h2l2,1l1,1l1,2c0,2,1,2,2,3l1,3v7l-1,3l-1,1h-1v2l-3,3c-2,0-2,1-3,2c-2,0-2,109-1,109l2,2v2h2l3,3v1h2c0,2,1,2,3,4v1h2c0,2,1,2,3,3l16,16v1h2l1,1c0,2,1,2,3,4v1h2v2h2l12,12v1h2l1,1c0,2,1,2,3,3l2,2c0,2,1,2,2,3v1h2l12,12v1l1-1l3-1h9l3,1l1,1v1h2l2,2l3,6v8l-1,2h-1v3l-5,5l-2,1l-3,1h-7l-4-1l-3-3v-1h-2l-2-4l-1-3v-8l1-2c1-1,0-1-3-4v-1h-2l-1-1v-2h-2l-3-3l-1-2v-1h-2l-16-16v-1h-2l-1-1v-2h-2l-13-13v-1h-2l-1-2v-1h-1l-4-4v-1h-2l-17-17v-1h-2c0-2-1-2-3-4v-1h-2l-1-2c0-112-2-112-6-114c0-2-1-2-4-5l-1-3v-10l2-4l4-4c3,0,3-1,4-2zm4,8v1h-3v1l-1,2h-1v7h1l1,1v1h2v1l4-1h3v-1l1-2h1v-5h-1v-2h-1l-1-1v-1h-3zm87,223h1v2h1l1,1v1h2l5,1v-1h2v-1l1-1h1v-7h-1l-2-2v-1h-7v1l-2,2h-1v2z"/><path d="M132,151h3l2,2l2,4v1l-1,1l-6,2l-12,3c-4,0,-4,1,-6,2c-5,0,-5,1,-13,3c-4,0,-4,1,-6,2l-4,1c-5,0,-5,1,-8,2c-5,0,-5,1,-7,2l-12,3c-5,0,-5,1,-11,3l-12,3c-4,0,-4,1,-5,5l-1,3l-2,2h-1v2l-2,2l-6,2h-7l-3,-1l-2,-1l-5,-5l-1,-2l-1,-3v-7l1,-3l1,-2l5,-5l2,-1l4,-1h5l4,1l4,2l1,1l1,2v1h5v-1c4,0,4,-1,7,-2l12,-3c4,0,4,-1,6,-2c5,0,5,-1,13,-3c4,0,4,-1,6,-2l8,-2l5,-1c4,0,4,-1,6,-2l16,-4c4,0,4,-1,7,-2Zm-111,42v-1h4v-2l1,-1h1l-1,-7v-2h-2l-7,-1v1l-1,1h-1v2h-1v5h1v2h1l1,1v1h3Z"/></g><g style="fill:rgb(19,4,252);fill-rule:evenodd;stroke:rgb(19,4,252);stroke-width:0.1;" id="l4"><path d="M133,50h5v8l-2,1c-7,0-7,1-10,2l-4,1c-4,0-4,1-7,2c-3,0-3,1-7,3c-3,0-3,1-7,3c-2,0-2,1-3,2c-2,0-2,1-3,2l-2,1h-2v2c-2,0-2,1-3,2c-2,0-2,1-3,3c-2,0-2,1-7,6l-3,3h-1v2l-3,3h-1v2l-1,1h-1v2l-1,2l-2,2h-1v3l-3,6l-1,1h-1v3l-1,3h-1v4l-2,6c-1,0-1,5-2,14h-1l1,15v8l-1,1c-4,0-4,1-6,2h-1l-1-4l-1-13v-4l1-13l1-4h1v-5l2-8l1-3l2-4h1v-3l1-2h1v-3l2-2h1v-3l1-1h1v-2l1-1h1v-2l1-1h1v-2l1-1h1v-2c2,0,2-1,3-3l12-12c2,0,2-1,6-5l2-1c2,0,2-1,3-2c2,0,2-1,3-2l4-2c2,0,2-1,3-2c3,0,3-1,5-2l3-1c3,0,3-1,5-2l3-1l4-1l5-1z"/><path d="M154,50h5l7,1l5,1l8,2l1,1v1h3l6,2l2,1v2l-3,6h-4l-6-3v-1h-4l-3-1v-1h-5l-2-1v-1h-8l-2-1zm51,19h3l4,4v1h2l1,1c0,2,1,2,3,3l3,3c0,2,1,2,3,3l1,1c0,2,1,2,2,3v2h2c0,2,1,2,2,3l1,2c0,2,1,2,3,4l3,6c0,3,1,3,2,4l1,2l2,6c0,3,1,3,2,5l1,3l1,5l1,6l1,11v11l-1,10l-1,6l-1,5l-1,4l-1,1h-1v4l-1,2h-1v3l-6,12l-1,1h-1v2l-1,1h-1v2l-1,2l-4,4h-1l-5-5v-2l2-4h2v-2l1-1h1v-2l1-2l1-1h1v-2l2-4h1v-3l1-1h1v-3l1-3h1v-4l1-4h1v-5l1-3h1c0-28-1-28-2-31c0-5-1-5-2-9c0-4-1-4-2-7c0-3-1-3-2-4l-1-2c0-3-1-3-2-4c0-3-1-3-3-5l-1-2c0-2-1-2-3-4c0-2-1-2-2-3c0-2-1-2-7-8v-2h-2l-6-6v-1h-2l-2-1v-2l1-1h1v-2l1-2z"/><path d="M56,184h2l1,2c0,3,1,3,2,4c0,3,1,3,3,7c0,2,1,2,3,4l1,2c0,2,1,2,2,3c0,2,1,2,4,5c0,2,1,2,6,7l6,6v1h2l3,3v1h2l1,1v1h2l2,1l1,1v1h2v3l-1,3l-1,2h-3l-6-3l-2-2v-1h-2l-1-1v-1h-2v-2h-2l-2-2v-1h-2v-2h-2l-3-3v-2h-2c0-2-1-2-3-4v-2h-2l-1-1l-1-2c0-2-1-2-2-3v-2h-2l-3-6c0-2-1-2-2-3l-1-2c0-3-1-3-2-5c0-3-1-3-2-5v-1l3-1z"/><path d="M208,223h1l3,3v1h2v3l-1,1c-2,0-2,1-5,4c-2,0-2,1-3,2c-2,0-2,1-3,2c-2,0-2,1-3,2l-12,6l-3,1c-3,0-3,1-5,2l-3,1l-8,2c-7,0-7,1-11,2h-21l-5-1v-1h-6l-5-1l-4-1l-2-1v-4l1-2h1v-3h1l4,1l2,1c0,1,4,1,11,2v1c24,0,24-1,31-2c4,0,4-1,13-4h4v-1c2,0,2-1,3-2c3,0,3-1,7-3c2,0,2-1,4-3l2-1c2,0,2-1,4-3c2,0,2-1,4-3z"/></g><g style="fill:rgb(4,188,236);fill-rule:evenodd;stroke:rgb(4,188,236);stroke-width:0.1;" id="l5"><path d="M94,79h10l2,1l1,1v1h2l3,3c0,2,1,2,2,3l1,5v3l-1,4l-1,1h-1c0,3,1,3,3,5c0,2,1,2,5,6c0,2,1,2,4,5c0,2,1,2,4,5c0,2,1,2,4,5c0,2,1,2,3,4l1,1c0,2,1,2,2,3v13h-1l-4,-4c0,-2,-1,-2,-3,-4c0,-2,-1,-2,-4,-5c0,-2,-1,-2,-5,-6c0,-2,-1,-2,-5,-6c0,-2,-1,-2,-5,-6c0,-2,-1,-2,-2,-3c0,-2,-1,-2,-3,-3c0,-2,-3,-1,-11,-1l-3,-1l-1,-1v-1h-2l-2,-2v-2h-2l-1,-3v-11l2,-4l5,-5Zm-2,14l1,3v2h1l2,2v1l6,-1h2v-1l1,-3h1l-1,-3v-3h-1l-1,-1v-1h-8v1l-1,1h-1v3Z"/><path d="M167,154h4l4,1v1h5l8,2v1h5l2,1v1h4v1c3,0,3-1,7-5l4-2h10l6,3l1,1c0,2,1,2,2,3l1,2l1,4v4l-1,4l-1,2l-2,2h-1v2l-1,1l-4,2h-11l-3-1l-2-1l-1-1c0-2-1-2-3-4l-1-2l-1-5c0-1-3-1-15-4v-1h-5l-2-1v-1h-4l-4-1l-6-6v-1l1-1zm44,10v1l-1,1h-1v3h-1l1,3v2h1l2,2v1l6-1h2v-2l1-2h1l-1-4v-2h-1l-1-1v-1h-2v-1l-4,1z"/><path d="M144,162h1l4,4v1h2l2,2l2,4l1,3l1,5c0,6,1,6,2,11c0,6,1,6,2,9c0,5,3,5,7,7l1,1v1h2l1,1c0,2,1,2,2,3l1,2v11l-1,3l-6,6l-3,1h-10l-4-2l-4-4l-2-4v-10l1-3l1-1h1v-2c2,0,2-1,4-3h1v-2h-1c0-6-1-6-2-11c0-6-1-6-2-8l-1-6c0-6-1-6-2-11l-1-6zm23,63v-6h-1l-3-3v-1h-6v1l-3,3h-1v5h1v2h1l2,1l1,1v1h4v-1l1-1h2v-1l1-1z"/></g><g style="fill:rgb(4,108,152);fill-rule:evenodd;stroke:rgb(4,108,152);stroke-width:0.1;" id="l6"><path d="M296,115h1v2h-1z"/></g><circle id="e3_circle" cx="146.297" cy="152.367" style="fill:white;stroke:none;stroke-width:1px;" r="70"/>
    <text
      :fill="leftColour"
      :font-size="fontsize"
      font-family="Open Sans"
      :x="textx"
      :y="texty"
    >{{partType}}</text>
    {{partType}}
</svg>
<v-icon v-if="externalIcon" :color="resolveHeaderStyle(file_info)">
  {{resolveExternalIcon(file_info)}}
</v-icon>  
</div>

</template>


<script>
export default {
  name: "PartTypeIcon",
  props: {
    partType: null,
    file_info: null,
    size: null
  },
  data() {
    return {
      height: 20,
      width: 36,
      x: 18,
      y: 10,
      textx: 80,
      texty: 200,
      fontsize: 170,
      leftColour: null,
      rightColour: null,
      externalIcon: false,
    };
  },
  mounted() {
    this.setup();
  },
  watch: {
    partType(newval) {
      if (newval) {
        this.setup();
      }
    },
    file_info(newval) {
      if(newval){
        this.externalIcon = true;
      }
    }
  },
  methods: {
      resolveExternalIcon(extension){
        if(extension !== null && extension !== undefined){
          switch(extension.file_extension){
              case "xlsx":
              case "xls":
                  return "mdi-microsoft-excel";
              case "doc":
              case "docx":
                  return "mdi-microsoft-word";
              case "txt":
              case "log":
                  return "mdi-file-document-outline";
              case "pdf":
                  return "mdi-file-pdf-box";
          }
        }


      },    
      resolveHeaderStyle(extension){

        if(extension !== null && extension !== undefined){
          switch(extension.file_extension){
              case "xlsx":
              case "xls":
                  return "#3cc542ad";
              case "doc":
              case "docx":
                  return "#327bb5c7";
              case "txt":
              case "log":
                  return "#ff23138f";
              case "pdf":
                  return "#ff23138f";
          }
        }

      },
    setup() {
      switch (this.size) {
        case "medium":
          this.height = 32;
          this.width = 32;
          this.texty = 196;
          this.textx = 90;
          break;
        default:
          this.height = 24;
          this.width = 24;
          this.texty = 195;
          this.textx = 95;
          break;
      }
      this.x = this.width / 2;
      this.y = this.height / 2;
      this.fontsize = 77 + (this.y * 4);
      let lcol = "",
        rcol = "";
      switch (this.partType.toLowerCase()) {
        case "jp":
          this.externalIcon = false;
          lcol = "green";
          rcol = "darkblue";
          break;
        case "ja":
          this.externalIcon = false;
          lcol = "blue";
          rcol = "darkgreen";
          break;
        case "jd":
          this.externalIcon = false;
          lcol = "red";
          rcol = "darkgray";
          break;
        case "ef":
          this.externalIcon = true;
          break;
        default:
          this.externalIcon = false;
          lcol = "lightcoral";
          rcol = "darkblue";
          break;
      }
      this.leftColour = lcol;
      this.rightColour = rcol;
    }
  }
};
</script>